import { makeAutoObservable, reaction, runInAction } from "mobx";
import { FullOverlayModalsControl } from "./FullOverlayModalsControl";
import { WaitingUtils } from "./WaitingUtils";

export class ReviewsStore {
  modal: FullOverlayModalsControl = new FullOverlayModalsControl();
  utils: WaitingUtils = new WaitingUtils();
  entity_type: "tour" | "fair" | "product" | "address" | "reply" = "product";
  entity_id: number = 1;
  name: string = "";

  new_reply: boolean = false;
  parent_id: number | null = null;
  text: string = "";
  senderName: string | null = null;
  visitorName: string | null = null;

  wait: boolean = false;

  constructor() {
    makeAutoObservable(this);

    reaction(
      () => this.modal.openModal,
      (open) => {
        if (!open) {
          this.clearReply();
        }
      },
    );
  }

  setEntity = (
    entity_id: number,
    entity_type: "tour" | "fair" | "product" | "address" | "reply",
    name?: string,
  ) => {
    runInAction(() => {
      this.entity_id = entity_id;
      this.entity_type = entity_type;
      this.name = name || "";
    });
  };

  setWait = (wait: boolean) => {
    runInAction(() => {
      this.wait = wait;
    });
  };

  setReply = (parent_id: number, new_reply: boolean, visitorName: string) => {
    runInAction(() => {
      this.new_reply = new_reply;
      this.parent_id = parent_id;
      this.visitorName = visitorName;
    });
  };

  setSenderName = (senderName: string) => {
    runInAction(() => {
      this.senderName = senderName;
    });
  };

  setText = (text: string) => {
    runInAction(() => {
      this.text = text;
    });
  };

  clearReply = () => {
    runInAction(() => {
      this.new_reply = false;
      this.parent_id = null;
      this.visitorName = null;
      this.text = "";
      this.senderName = null;
      this.wait = false;
    });
  };
}

export const reviewsStore = new ReviewsStore();
